import Skeleton from "@mui/material/Skeleton";
import React, { Component } from "react";
import "../../resources/profilePreview.css";
import userService from "../../services/userService";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

class ProfilePreview extends Component {
  state = {
    loadedProfile: false,
    errorOccurred: false,
    profile: {},
  };

  async componentDidMount() {
    await this.getUserDetails();
  }

  getUserDetails = async () => {
    setTimeout(async () => {
      try {
        const { username } = this.props;
        const response = await userService.getUserDetails(username);
        this.setState({
          loadedProfile: true,
          profile: response.data.data,
        });
      } catch (err) {
        this.setState({
          errorOccurred: true,
        });
      }
    }, 500);
  };

  render() {
    const { loadedProfile, errorOccurred, profile } = this.state;
    const { onClick } = this.props;

    if (errorOccurred) {
      return (
        <div
          className="profile-preview"
          style={{
            fontWeight: "initial",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "red",
          }}
        >
          <ErrorOutlineIcon
            style={{
              marginRight: 10,
            }}
          />
          Failed to load profile preview
        </div>
      );
    }

    if (!loadedProfile) {
      return (
        <div className="profile-preview">
          <Skeleton variant="rectangular" height={70} />
          <div
            style={{
              padding: 10,
              position: "absolute",
              top: 45,
              left: 30,
              backgroundColor: "white",
              borderRadius: "50%",
            }}
          >
            <Skeleton variant="circular" width={45} height={45} />
          </div>
          <div
            style={{
              marginTop: 40,
            }}
          >
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      );
    }

    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;

    return (
      <div className="profile-preview" onClick={onClick}>
        <div className="banner">
          <img src={backendApiPath + `/profile/${profile.username}/banner`} />
        </div>
        <div className="profile-pic">
          <div className="img-container">
            <img src={backendApiPath + `/profile/${profile.username}/pic`} />
          </div>
        </div>
        <div
          style={{
            marginLeft: 10,
          }}
        >
          <div>
            <h3
              style={{
                marginTop: 25,
                marginBottom: 10,
              }}
            >
              {profile.username}
            </h3>
          </div>
          <div
            style={{
              marginBottom: 10,
              fontWeight: "initial",
            }}
          >
            {profile.bio}
          </div>
          <div
            className="stats"
            style={{
              marginBottom: 10,
            }}
          >
            <div className="stat">
              <b>{profile.posts}</b> post{profile.posts != 1 && 's'}
            </div>
            <div className="stat">
              <b>{profile.followers}</b> follower{profile.followers != 1 && 's'}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProfilePreview;
